// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"55fd2a0c91cee694e138","339":"28be52cdb961c17d775f"}[chunkId] + ".js";
};